import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class SubmissionService { 
  baseUrl = environment.baseUrl;
  
  constructor(
    private http: HttpClient, 
  ) { }

  getSubmissions$(uuid: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    let offset = page * 10;
    return this.http.get<any>(url + '/sub2?uuid=' + uuid + '&offset=' + offset);
  }

  getRoofTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'roof-types?uuid=' + uuid);
  }

  getRoofAccessTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'building-access?uuid=' + uuid);
  }
  
  addSubmission$(uuid: string, submissionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    return this.http.post<any>(url + '?uuid=' + uuid, submissionInfo, httpOptions);
  }

  getSubmission$(submissionId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    return this.http.get<any>(url + submissionId + '?uuid=' + uuid);
  }

  updateSubmission$(submissionId: number, uuid: string, submissionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    return this.http.put<any>(url + submissionId + '?uuid=' + uuid, submissionInfo, httpOptions);
  }

  updateSubmissionState$(submissionId: number, uuid: string, submissionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    return this.http.put<any>(url + submissionId + '/state?uuid=' + uuid, submissionInfo, httpOptions);
  }

  searchSubmission$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    let offset = page * 10;
    //lookup2
    return this.http.get<any>(url + 'search?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
    
  }
  
  searchStateSubmission$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    let offset = page * 10;
    console.log('url not assigned list',url + 'filter/' + search + '&uuid=' + uuid + '&offset=' + offset);
    return this.http.get<any>(url + 'filter/' + search + '&uuid=' + uuid + '&offset=' + offset);
  }

  searchSubmissionNoLimit$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    let offset = 0;
    let limit = 9999;
    return this.http.get<any>(url + 'search?query=' + search + '&uuid=' + uuid + '&limit=' + limit + '&offset=' + offset);
  }

  //hide submissions from the left hand list in calendar vendeur
  putOnHoldSubmission$(uuid: string, submissionId: number,): Observable<any> {
      let url = `${this.baseUrl}${ApiPaths.submissions}`;
      //console.log('put notes', url + '?uuid=' + uuid, info, httpOptions);
      return this.http.put<any>(url + submissionId + '/hold?uuid=' + uuid, httpOptions);
  }

  //hide submissions from the left hand list in calendar vendeur
  removeHoldSubmission$(uuid: string, submissionId: number,): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    //console.log('put notes', url + '?uuid=' + uuid, info, httpOptions);
    return this.http.post<any>(url + submissionId + '/hold?uuid=' + uuid, httpOptions);
}

  // Contracts
  getContracts$(uuid: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    let offset = page * 10;
    return this.http.get<any>(url + '/filter/state?is_accepted=true&is_signed=true&uuid=' + uuid + '&offset=' + offset);
  }

  searchContract$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    let offset = page * 10;
    return this.http.get<any>(url + 'search?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
  }
}
